import { motion } from "framer-motion";
import { Instagram, Mail, ArrowUp } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#070A13] text-[#FDFBF7]"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
                <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="font-display text-5xl md:text-8xl lg:text-9xl tracking-tighter leading-[0.9] mb-16"
                >
                    Get to{" "}
                    <span className="italic text-[#C5A059]">green</span>.
                </motion.p>

                <div className="grid md:grid-cols-12 gap-10 pt-10 border-t border-white/10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 mb-3">
                            <Logo className="w-8 h-8" dark />
                            <p className="font-display text-2xl">
                                The Raw Math
                            </p>
                        </div>
                        <p className="font-body text-white/50 max-w-xs">
                            Money math and common sense. The clear numbers no
                            one else will show you.
                        </p>
                    </div>

                    <div className="md:col-span-3 md:col-start-7">
                        <p className="overline text-white/40 mb-4">Follow</p>
                        <a
                            data-testid="footer-instagram"
                            href="https://instagram.com/the_rawmath"
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-2 text-white/80 hover:text-[#C5A059] transition-colors duration-300 mb-3"
                        >
                            <Instagram size={16} /> @the_rawmath
                        </a>
                        <a
                            data-testid="footer-email"
                            href="mailto:hello@theRawMath.com"
                            className="flex items-center gap-2 text-white/80 hover:text-[#C5A059] transition-colors duration-300"
                        >
                            <Mail size={16} /> hello@theRawMath.com
                        </a>
                    </div>

                    <div className="md:col-span-2 md:col-start-11 flex md:justify-end items-start">
                        <button
                            data-testid="back-to-top"
                            onClick={() =>
                                window.scrollTo({ top: 0, behavior: "smooth" })
                            }
                            className="group flex items-center gap-2 overline text-white/60 hover:text-[#FDFBF7] transition-colors duration-300"
                        >
                            Back to top
                            <span className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center group-hover:border-[#C5A059] group-hover:-translate-y-1 transition-all duration-300">
                                <ArrowUp size={16} />
                            </span>
                        </button>
                    </div>
                </div>

                <p className="font-mono text-xs text-white/30 mt-16">
                    © {new Date().getFullYear()} The Raw Math — All rights
                    reserved.
                </p>
            </div>
        </footer>
    );
};
